export default __webpack_public_path__ + "static/media/global-icon-one.d3697503.svg";